import { QueryConditionFilter, QueryFilter } from '@softline/core';
import { MetaFormBody } from '../types/meta-form-body';

interface MachineRow {
  [key: string]: unknown;
}

function toQueryFilter(name: string, value: unknown): QueryFilter<MachineRow> | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'boolean')
    return value
      ? ({ type: 'stringEquals', name, value: 'J' } as unknown as QueryFilter<MachineRow>)
      : null;
  if (typeof value === 'number')
    return { type: 'numberEquals', name, value } as unknown as QueryFilter<MachineRow>;
  if (typeof value === 'string')
    return { type: 'stringLike', name, value } as unknown as QueryFilter<MachineRow>;
  if (Array.isArray(value) && value.length > 0) {
    const allNumbers = value.every((v) => typeof v === 'number');
    return allNumbers
      ? ({ type: 'numberSet', name, values: value } as unknown as QueryFilter<MachineRow>)
      : ({
          type: 'stringSet',
          name,
          values: value,
        } as unknown as QueryFilter<MachineRow>);
  }
  if (typeof value === 'object' && !Array.isArray(value)) {
    const id = (value as Record<string, unknown>)['id'];
    if (id === null || id === undefined) return null;
    if (typeof id === 'number')
      return {
        type: 'numberEquals',
        name,
        value: id,
      } as unknown as QueryFilter<MachineRow>;
    if (typeof id === 'string')
      return {
        type: 'stringLike',
        name,
        value: id,
      } as unknown as QueryFilter<MachineRow>;
  }
  return null;
}

export function buildMachineQueryPayload(
  formValue: Record<string, unknown> | null,
  metaFormBody: MetaFormBody | null,
  limit = 10,
  offset = 0
) {
  const filters: QueryFilter<MachineRow>[] = [];
  const customFilters: QueryFilter<MachineRow>[] = [];

  const add = (target: QueryFilter<MachineRow>[], name: string, value: unknown): void => {
    const entry = toQueryFilter(name, value);
    if (entry) target.push(entry);
  };

  add(filters, 'vehicleMainClassId', metaFormBody?.vehicleMainClassId);
  add(filters, 'vehicleSubClassId', metaFormBody?.vehicleSubClassId);

  for (const [key, value] of Object.entries(formValue ?? {})) {
    if (key === '_custom') continue;
    add(filters, key, value);
  }

  const custom = formValue?.['_custom'];
  if (custom && typeof custom === 'object' && !Array.isArray(custom)) {
    for (const subValue of Object.values(custom as Record<string, unknown>)) {
      if (subValue && typeof subValue === 'object' && !Array.isArray(subValue)) {
        for (const [key, value] of Object.entries(subValue as Record<string, unknown>)) {
          add(customFilters, key, value);
        }
      }
    }
  }

  const filter: QueryConditionFilter<MachineRow> = {
    type: 'conditions',
    operator: 'AND',
    filters,
  };
  const customFilter: QueryConditionFilter<MachineRow> = {
    type: 'conditions',
    operator: 'AND',
    filters: customFilters,
  };

  return { filter, customFilter, limit, offset };
}
